import { styled } from '../../../../common';
import { Box } from '../../../Box';

export const DialogBodyContainer = styled(Box)`
  min-height: 128px;
  position: relative;
`;
